import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api';

function ProfileCheck({ children }) {
  const [loading, setLoading] = useState(true);
  const [hasProfiles, setHasProfiles] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    checkProfiles();
  }, []);

  const checkProfiles = async () => {
    try {
      const response = await api.get('/api/profiles/');
      const profiles = response.data;
      setHasProfiles(profiles && profiles.length > 0);
      setLoading(false);
    } catch (error) {
      console.error('Error checking profiles:', error);
      setError(error);
      // If there's an error fetching profiles, redirect to profile creation
      // This ensures users don't get stuck if they have no profiles
      setHasProfiles(false);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading-container" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column',
        background: 'linear-gradient(135deg, #1e1e2f 0%, #2d2b42 100%)'
      }}>
        <div className="loading-spinner" style={{
          width: '40px',
          height: '40px',
          border: '4px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '50%',
          borderTopColor: '#9333ea',
          animation: 'spin 1s linear infinite',
          marginBottom: '1rem'
        }}></div>
        <p style={{ color: 'rgba(255, 255, 255, 0.7)' }}>Loading your profiles...</p>
        <style>
          {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (error && !hasProfiles) {
    return <Navigate to="/create-profile" />;
  }

  return hasProfiles ? children : <Navigate to="/create-profile" />;
}

export default ProfileCheck; 